import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const EditorFooterContainer = styled.div`
  position: sticky;
  padding: 5px 10px 0px 10px;
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
`
const LeftContainer = styled.div`
  display: flex;
  align-items: flex-end;
`
const RightContainer = styled.div`
  display: flex;
  align-items: flex-end;
`
const SaveAsDraftButton = styled.button`
  height: 27px;
  border-radius: 4px;
  background-color: #FFFFFF;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  color: #3399CC;
  font-family: "Open Sans";
  border: 2px solid #3399CC;
  margin-right: 15px;
  &:disabled {
    border: 2px solid #DBDBDC;
    background-color: #FFFFFF;
    color: #DBDBDC;
    cursor: default;
  }
`
const PostButton = styled.button`
  height: 27px;
  border-radius: 4px;
  background-color: #3399CC;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  color: #FFFFFF;
  border: none;
  margin-right: 15px;
  &:disabled {
    background-color: #DBDBDC;
    color: #FFFFFF;
    cursor: default;
  }
`
const DeleteButton = styled.div`
  margin-left: 15px;
  margin-bottom: 5px;
  cursor: pointer;
  height: 19px;
  width: 43px;
  color: #BC3C4B;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
`

const EditorFooter = ({ onPostClick, onDeleteClick, disabled, published, onSaveAsDraftClick, isBankUser, predefined, onLinkButtonClick, onFileUploadClick, ToolbarComponent }) => {
  const DeleteText = 'Delete'
  const SaveAsDraftText = 'Save as Draft'
  const postButtonText = `Publish to  ${isBankUser ? "SmartBiz" : "Bank"}`

  return (
    <EditorFooterContainer>
      <LeftContainer>
        <ToolbarComponent onLinkButtonClick={onLinkButtonClick} onFileUploadClick={onFileUploadClick} />
        {!predefined && (
          <DeleteButton onClick={onDeleteClick}>{DeleteText}</DeleteButton>
        )}
      </LeftContainer>
      <RightContainer>
        {!published && (
          <SaveAsDraftButton disabled={disabled} onClick={onSaveAsDraftClick}>
            {SaveAsDraftText}
          </SaveAsDraftButton>
        )}
        <PostButton disabled={disabled} onClick={onPostClick}>
          {postButtonText}
        </PostButton>
      </RightContainer>
    </EditorFooterContainer>
  )
}

EditorFooter.propTypes = {
  lastSaved: PropTypes.number,
  onDeleteClick: PropTypes.func.isRequired,
  onLinkButtonClick: PropTypes.func.isRequired,
  onPostClick: PropTypes.func.isRequired
}

export default EditorFooter
